import * as React from "react";
import AreaTitle from "components/AreaTitle";

const DashboardLayout: React.StatelessComponent<{}> = props => {
    return (
        <div>
            <AreaTitle
                link="/"
                title="Dashboard"
            />
            {props.children}
        </div>);
};

export default DashboardLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/dashboard/DashboardLayout/DashboardLayout.tsx